<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14u3pBy/tc-custom/9781788487474.jpg?1705766095375" alt="This image is the cover for the book Vi and Vincent the Jibber Jabbers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vi and Vincent the Jibber Jabbers
      </h1>
      <p class="bookDescription body article font2">
        <p>Amy’s off to get a vaccine today but her big brother isn’t impressed, as he wanted to stay home and play. But suddenly the vaccine starts talking to him – and him alone. Join us for a stimulating and enthralling journey to discover just how vaccines work and how they can keep so many of us safe and healthy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Celia Brown
      </h2>
      
      <p class="authorDescription body article">Celia Brown is a Professor of Medical Education at Warwick Medical School. One of her favourite activities is reading to her son, hoping to inspire a love of reading. The hours she spends reading to him inspired her to take up the challenge of authoring a book herself. Celia is a STEM (Science, Technology, Engineering and Mathematics) Ambassador, leading outreach events in local schools and at the University of Warwick to share her other passion – mathematics and statistics. Celia is also a keen cyclist, getting inspiration for her work while out in the countryside.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ffd2731